module.exports = __webpack_public_path__ + "img/sr.1adc76db.svg";